module.exports = __webpack_public_path__ + "7d862262c32b7e445baa70c7b4a5acf9.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/charts/stryker_2023_chart.png
// module id = 1736
// module chunks = 0